@if (readonly()) {
    <!-- Lixeira e favoritos: só leitura, com o mesmo viewer do PDF. -->
    <ra-viewer-text [content]="readText()" [fontFamily]="fontFamily()" />
} @else {
    <ra-editor
        [value]="editorValue()"
        [placeholder]="placeholder()"
        [showToolbar]="false"
        [showLimitCharacters]="false"
        [inline]="true"
        [disabled]="blocked()"
        (onFocus)="onFocus()"
        (change)="onChange($event)"
        (onLeave)="onLeave($event)"
        (formatChange)="onFormatChange($event)"
    />

    <!-- Cursor da edição (o nativo fica transparente enquanto o editor está em foco). A
         posição é escrita direto no elemento, no mesmo quadro da medida (ver _measureCaret). -->
    <span #caretEl class="fat-caret" aria-hidden="true" [hidden]="!caretVisible()"></span>
}
